import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { TerraIconModule, TerraIconName } from '@ninety/terra';
import { ButtonComponent } from '@ninety/ui/core';

export interface MeetingViewTool {
  /** Route segment(s) under `meeting/:id` — `'data'`, or `['knowledge', 'library']` for Knowledge. */
  segment: string | string[];
  label: string;
  icon: TerraIconName;
}

@Component({
  standalone: true,
  selector: 'ninety-meeting-sidenav-tools-menu',
  templateUrl: './meeting-sidenav-tools-menu.component.html',
  styleUrls: ['./meeting-sidenav-tools-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TerraIconModule, MatMenu, MatMenuItem, MatMenuTrigger, RouterLink, RouterLinkActive],
})
export class MeetingSidenavToolsMenuComponent {
  /** Already filtered by the parent — every tool passed in is one this user may see. */
  readonly tools = input<MeetingViewTool[]>([]);

  readonly meetingId = input.required<string>();
  /** True until a meeting has loaded, matching the sibling action buttons. */
  readonly disabled = input(false);

  readonly toolSelected = output<string>();

  /**
   * `detail: null` closes the detail panel as we navigate — drop it and a detail view stays open
   * over the newly selected tool.
   */
  protected routerLinkFor(tool: MeetingViewTool): unknown[] {
    const segments = Array.isArray(tool.segment) ? tool.segment : [tool.segment];
    return [{ outlets: { detail: null, primary: ['meeting', this.meetingId(), ...segments] } }];
  }
}
